import Cookies from 'js-cookie'

export const cookies = Cookies.withConverter({
  write: function (value) {
    return encodeURIComponent(value)
  },
  read: function (value) {
    return decodeURIComponent(value)
  },
})

export function getDomain() {
  // creates cookieDomain like '.aok.de'
  let domain = ''
  if (window.location.hostname !== 'localhost') {
    const reversedDomainParts = window.location.hostname.split('.').reverse()
    domain = `.${reversedDomainParts[1]}.${reversedDomainParts[0]}`
  }

  return domain
}

const userSettingsCookieName = 'user_cookie_settings'

// shortcuts
export const hasComfortSettings = () => {
  const cookie = cookies.get(userSettingsCookieName)
  const jsonData = cookie ? JSON.parse(cookie) : null

  return jsonData?.comfort?.approved || false
}

export const isSettingsCookieHidden = () => {
  const cookie = cookies.get('aok_cookie_settings')
  return !!cookie
}
